<template>
  <ul class="spotlight-list__wrapper">
    <li
      v-for="item in $options.consts.ITEMS"
      :key="item.title"
      class="spotlight-list__item"
    >
      <a-icon
        :icon="$options.consts.ICON.ROUND_CHECK_MARK"
        width="auto"
        height="auto"
        :no-hover="true"
        :original="true"
        class="spotlight-list__icon"
      />

      <span class="spotlight-list__title">{{ item.title }}</span>
    </li>
  </ul>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'

export default {
  name: 'HomepageSpotlightSectionList',
  components: { AIcon },
  consts: {
    ICON,
    ITEMS: [
      {
        title: 'Cited by Experts'
      },
      {
        title: 'Referenced Worldwide'
      },
      {
        title: 'Influential in Finance'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
.spotlight-list__wrapper {
  .spotlight-list__item {
    display: flex;
    align-items: center;

    $margin-bottom: (
      $above-desktop-xl: 25px,
      $desktop-sm: 10px,
      $mobile: 14px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .spotlight-list__icon {
    $size: (
      $above-desktop-xl: 40px,
      $desktop-sm: 32px,
      $mobile: 28px
    );

    $margin-right: (
      $above-desktop-xl: 20px,
      $desktop-sm: 15px,
      $mobile: 10px
    );

    @include setStyleByBreakpoint('width', $size);
    @include setStyleByBreakpoint('height', $size);
    @include setStyleByBreakpoint('margin-right', $margin-right);
  }

  .spotlight-list__title {
    $font-size: (
      $above-desktop-xl: 26px,
      $desktop-sm: 14px,
      $mobile: 12px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
  }
}
</style>
